import { AlertBox } from '@spotahome/ui-library';

import { trans } from '@spotahome/soyuz/client';

import './BookingBarNotAvailable.scss';

const BookingBarNotAvailable = () => {
  return (
    <div className={'booking-bar-not-available'}>
      <AlertBox
        message={trans('listing.book-now-not-available.alertbox-message')}
        roundedCorners
        theme="info"
      />
    </div>
  );
};

export default BookingBarNotAvailable;
